// App.jsx
import { DS } from '@/design-system'
import { BadgeArt } from '@/assets/badges/badgeAssets'
import { TIER_PALETTES } from '@/assets/badges/palettes'
import { tierName, type BadgeDefinition } from '@ppwr/convex/badges/catalog'
import { View } from 'react-native'
import { BaseToast, type ToastConfigParams } from 'react-native-toast-message'

/** Custom props for ppBadgeToast: which badge (and tier) to render as the leading icon. */
type BadgeToastProps = {
  badge?: BadgeDefinition
  tier?: number
}

const BADGE_TOAST_ART_SIZE = 36

/*
  1. Create the config
*/
export const toastConfig = {
  ppToast: (props: { props?: any }) => (
    <BaseToast
      {...props}
      style={{ borderLeftColor: DS.palette['Brand/Pink'] }}
      contentContainerStyle={{ paddingHorizontal: 15 }}
      text1Style={{
        fontSize: 15,
        fontWeight: '400'
      }}
    />
  ),
  // Badge unlocks: the badge name (text2) is the payload, so it reads larger
  // and darker than BaseToast's default subtitle styling. The earned badge's
  // art renders on the left at its tier palette; summary toasts (no badge in
  // props) stay icon-free.
  ppBadgeToast: ({ props, ...rest }: ToastConfigParams<BadgeToastProps>) => {
    const badge = props?.badge
    const tier = props?.tier ?? 0
    return (
      <BaseToast
        {...rest}
        style={{ borderLeftColor: DS.palette['Brand/Purple'] }}
        contentContainerStyle={{ paddingHorizontal: 15 }}
        renderLeadingIcon={
          badge
            ? () => (
                <View style={{ marginLeft: 10, alignSelf: 'center' }}>
                  <BadgeArt badge={badge} palette={TIER_PALETTES[tierName(badge, tier)]} size={BADGE_TOAST_ART_SIZE} />
                </View>
              )
            : undefined
        }
        text1Style={{
          fontSize: 13,
          fontWeight: '400',
          color: DS.palette['Brand/Dark Grey']
        }}
        text2Style={{
          fontSize: 16,
          fontWeight: '600',
          color: DS.palette['Global/Black']
        }}
      />
    )
  }
}
